import React from "react";
import { Tooltip } from "antd";
import { BoldOutlined, ItalicOutlined, StrikethroughOutlined, CodeOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";

// Marcadores de formato de WhatsApp.
const OPCIONES = [
  { marca: "*", icon: <BoldOutlined />, tip: "Negrita" },
  { marca: "_", icon: <ItalicOutlined />, tip: "Cursiva" },
  { marca: "~", icon: <StrikethroughOutlined />, tip: "Tachado" },
  { marca: "```", icon: <CodeOutlined />, tip: "Monoespaciado" },
];

const BarraFormato = ({ targetId, value, onChange }) => {
  const envolver = (marca) => {
    const el = document.getElementById(targetId);
    if (!el || typeof el.selectionStart !== "number") {
      onChange((value || "") + marca + marca);
      return;
    }
    const s = el.selectionStart;
    const e = el.selectionEnd;
    const sel = value.slice(s, e);
    const nuevo = value.slice(0, s) + marca + sel + marca + value.slice(e);
    onChange(nuevo);
    setTimeout(() => {
      el.focus();
      const pos = sel ? e + marca.length * 2 : s + marca.length;
      el.setSelectionRange(pos, pos);
    }, 0);
  };

  return (
    <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
      {OPCIONES.map((o) => (
        <Tooltip key={o.marca} title={o.tip} zIndex={1300}>
          <ButtonItem gris icon={o.icon} onClick={() => envolver(o.marca)} />
        </Tooltip>
      ))}
    </div>
  );
};

export default BarraFormato;
